import React, { useEffect, useRef, useState } from "react";
import home from "../assets/kangaroo/Purple House.png";
import arrow from "../assets/kangaroo/arrow-cropped.svg";
import { Col, Container, Row } from "reactstrap";
import { useNavigate } from "react-router-dom";
import Button from "../component/button/Button";
import { imageBaseApi } from "../services/imageBaseApi";
import "../Homepage/Component/Homepage.css";

const LearnMore = ({ data }) => {
  const router = useNavigate();
  const textRef = useRef(null);
  const [textHeight, setTextHeight] = useState(0);
  console.log(data)

  useEffect(() => {
    if (textRef.current) {
      setTextHeight(textRef.current.offsetHeight);
    }
    const handleResize = () => {
      if (textRef.current) {
        setTextHeight(textRef.current.offsetHeight - 1000);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  
  return (
    <div className="main-container">
      <Container
        fluid
        className=" d-flex justify-content-center align-items-end p-0"
      >
        <Row className="w-100 m-0">
          

          <Col
            xs={12}
            lg={6}
            className="d-flex flex-column justify-content-end align-items-center pt-4  ps-lg-4"
            style={{ marginBottom: "clamp(3rem, 6.1vw, 7.5rem)" }}
          >
            <div ref={textRef}>
              <h2 className="font-level-4 mb-3 lh-1">
                {data?.[0]?.heading}
              </h2>
              <div className="col-11">
                <p className="font-level-2 w-100 paragraph-margin">
                  {data?.[0]?.description}
                </p>
              </div>
              <div onClick={() => { router(data?.[0]?.buttonUrl) }}>
                <Button
                  label={data?.[0]?.buttonText}
                  width="100%"
                  height="60.8861px"
                  fontSize={22}
                  textColor={data[0]?.buttonColor}
                  fontWeight="800"
                  x={30}
                  fontFamily="Proxima Nova Bold"
                  textAlign="left"
                />
              </div>
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            className="d-flex justify-content-start align-items-end ps-0 mb-0 "
           
       
          >
            <img
              src={imageBaseApi + data?.[0]?.media?.url}
              alt="Kangaroo Education Foundation building"
              className="img-fluid  w-100 h-100"
              fluid
              style={{maxHeight:"650px", objectFit:"cover"}}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default LearnMore;